import { shape, string } from 'prop-types';
import cityBasicInformationPropTypes from '../../city/proptypes/CityPropTypes';

const districtBasicInformationPropTypes = {
  name: string,
  city: shape(cityBasicInformationPropTypes),
};

export default districtBasicInformationPropTypes;
